import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { debounceTime } from 'rxjs/operators';
import { Login } from '../login/login';

@Injectable({
  providedIn: 'root'
})
export class MedicamentoService {
  url: string;
  token: any;

  constructor(
    private http: HttpClient,
    private configService: ConfigService
  ) { 
    this.url = configService.getURL() + 'medicamento';
    this.token = new Login();
  }

  all(page = 1, tipoPesquisa = null,buscar = ''){
    return this.http.get<Object[]>(this.url + '?page=' + page + '&q=' + buscar + '&tipoPesquisa=' + tipoPesquisa, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  search(buscar: any){
    return this.http.get<Object[]>(this.url+ '?q=' + buscar, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    }).pipe(debounceTime(5000));
  }

  criar(medicamento : any) {
    return this.http.post<Object[]>(this.url, medicamento, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }
  
  ativar(idmedicamento: any){
    return this.http.get<Object[]>(this.url+ '/ativar/' + idmedicamento, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  inativar(idmedicamento: any){
    return this.http.get<Object[]>(this.url+ '/inativar/' + idmedicamento, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  atualizar(p : any) {
    return this.http.put<Object[]>(this.url + '/' + p.idmedicamento, p, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }


  detalhar(idmedicamento){
    return this.http.get<Object[]>(this.url + '/' + idmedicamento, {
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

  uploadXLSX(base64, criar_atualizar, original_nome, ignorar_primeira_linha, inativar_prod_inexistente) {
    return this.http.post<Object[]>(this.url + '/importar/xlsx', {
      base64: base64,
      criar_atualizar: criar_atualizar,
      original_nome: original_nome,
      ignorar_primeira_linha: ignorar_primeira_linha,
      inativar_prod_inexistente: inativar_prod_inexistente
    }, {
      headers: new HttpHeaders({'Authorization': 'Bearer ' + this.token.getToken() })
    });
  }

  mapearColunas(idtemp_medicamento_xlsx, colunas){

    return this.http.post<Object[]>(this.url + '/importar/xlsx/mapear-colunas/' + idtemp_medicamento_xlsx,{colunas: colunas}, {
      headers: new HttpHeaders({ 
        'Authorization': 'Bearer ' + this.token.getToken() 
      })
    });
  }

  importacoes(page = 1, dataInicial = '', dataFinal = ''){
    return this.http.get<Object[]>(this.url + '/xlsx?page=' + page + '&dataInicial=' + dataInicial + '&dataFinal=' + dataFinal, {
      headers: new HttpHeaders({ 
        'Authorization': 'Bearer ' + this.token.getToken() 
      })
    });
  }

  reimportar(idtemp_medicamento_xlsx){
    return this.http.post<Object[]>(this.url + '/importar/xlsx/reimportar/' + idtemp_medicamento_xlsx, {}, {
      headers: new HttpHeaders({ 
        'Authorization': 'Bearer ' + this.token.getToken() 
      })
    });
  }

  getFalhas(idtemp_medicamento_xlsx, page = 1){
    return this.http.get<Object[]>(this.url + '/importar/xlsx/falhas/' + idtemp_medicamento_xlsx + '?page=' + page, {
      headers: new HttpHeaders({ 
        'Authorization': 'Bearer ' + this.token.getToken() 
      })
    });
  }

  downloadPlanilhaExemplo(){
    return this.http.get<Object[]>(this.url + '/planilha-exemplo/download', {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.token.getToken() }) 
    });
  }

}
